import Pure from './pure.vue';
import MobPure from './mob-pure.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/performance_report/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	pure: withProvider(Pure, useSelfContext),
	'mob-pure': withProvider(MobPure, useSelfContext)
};
